export default "__VITE_ASSET__538bb4d5__"